import {Component, OnInit} from '@angular/core';
import {MxInformationTooltipConfig} from "mx-core";
import {combineLatestAll, of} from "rxjs";
import {PrlDashboardDataService} from "../../services/dashboard/prl-dashboard-data.service";

@Component({
  selector: 'prl-dashboard-monthly-commission',
  standalone: false,
  templateUrl: './prl-dashboard-monthly-commission.component.html',
  styleUrl: './prl-dashboard-monthly-commission.component.scss'
})
export class PrlDashboardMonthlyCommissionComponent implements OnInit {

    commissionConfig: MxInformationTooltipConfig = {
        links: [],
        header: 'Help',
        content: 'label.dashboard.monthly.commission.help'
    };

    dateConfig: MxInformationTooltipConfig = {
        links: [],
        header: 'Help',
        content: 'label.dashboard.calculated.date.help'
    };

    monthlyCommission: number = 0;
    calculatedDate: Date;

    constructor(private readonly monthlyCommissionDataService: PrlDashboardDataService) { }

    ngOnInit(): void {
        of(
            this.monthlyCommissionDataService.getCurrentEarning(),
            this.monthlyCommissionDataService.getCalculatedDate()
        )
            .pipe(combineLatestAll())
            .subscribe((response) => {
                this.monthlyCommission = response[0] as number;
                this.calculatedDate = new Date(response[1] as Date);
            });
    }

    getCalculatedDate = (): number => {
        if (!this.calculatedDate) {
            return 0;
        }

        return this.calculatedDate.getTime();
    };
}
